import React, { useState, useRef } from "react";
import '../styles/CentralArrow.css';
import {AnimatePresence} from "framer-motion";
import {motion} from "framer-motion";
import { ReactComponent as FAQHeader } from '../web_elements/TextSVG/faq-header-o.svg';
import { ReactComponent as FAQAnswers } from '../web_elements/TextSVG/faq-answers-o.svg';
import FAQ from "./FAQ";
import CallToAction from "./CallToAction";
import { ReactComponent as FAQSVG } from '../web_elements/TextSVG/textbox4_faq_svg-o.svg'
const CentralArrow = () => {
    const [isOpen, setIsOpen] = useState(false);
    const scrollToSectionRef = useRef(null); // Reference to the scroll target
    const toggleOpen = () => {
        setIsOpen(!isOpen);
        // Scroll smoothly to the section when opening
        if (!isOpen && scrollToSectionRef.current) {
            scrollToSectionRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                paddingTop: "100px",
                paddingBottom: "100px"
            }}
        >
            <div id="faq-heading">
                <FAQHeader
                    style={{
                        width: "60%",
                        height: "auto"
                    }}
                />
            </div>
            {/* Arrow */}
            <div id="arrow-container">
            <div
                id="arrow"
                onClick={toggleOpen}
                style={{
                    width: 0,
                    height: 0,
                    borderLeft: "30px solid transparent",
                    borderRight: "30px solid transparent",
                    borderTop: "30px solid white", // Triangle color
                    cursor: "pointer",
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", // Rotate when toggled
                    transition: "transform 0.8s ease", // Smooth animation
                }}
            >
            </div>
            </div>
            <AnimatePresence>
                {isOpen && (
                <motion.div
                    key="text"
                    ref={scrollToSectionRef}
                    initial={{ opacity: 0, y: -20 }}
                    animate={{ opacity: 1, y: 50 }}
                    exit={{ opacity: 0, y: 20 }}
                    transition={{ duration: 1 }}
                    style={{
                        marginTop: "20px",
                        marginBottom: "20px",
                        color: "white",

                    }}
                >
                    <FAQAnswers
                        style={{
                            width: "60%",
                            height: "auto"
                        }}/>
                </motion.div>
            )}
            </AnimatePresence>
        </div>
    );
};

export default CentralArrow;
